import * as React from "react";
import {
  AudioWaveform,
  BookOpen,
  Bot,
  Command,
  Frame,
  GalleryVerticalEnd,
  Map,
  PieChart,
  Settings2,
  SquareTerminal,
} from "lucide-react";

// TODO: Подчистить или что-то сделать
import { NavMain } from "@/components/layout/nav-main.tsx";
import { NavProjects } from "@/components/layout/nav-projects.tsx";
import { NavUser } from "@/components/layout/nav-user.tsx";
import { TeamSwitcher } from "@/components/layout/team-switcher.tsx";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/shadcn/sidebar.tsx";
import Logo from "@/components/partials/header/Tools/Logo";
import {Icon} from "@/components/Icon.tsx";
import { useContext, useState } from "react";
import Branding from "@/utils/branding.ts";
import Navmenu from "@/components/partials/sidebar/Navmenu";

import { menuItems } from "@/constant/menu-items.ts";
import { Link, useLocation, useParams } from "react-router-dom";
import { chatbotListQuery } from "@/store/chatbot.ts";
import { useSidebar } from "@/components/shadcn/sidebar";
import SideBar from "@/components/chat/components/SideBar.tsx";
import { UserContext } from "@/store/context/UserContext.tsx";
import { useTranslation } from "react-i18next";
import { ProfileSidebarButton } from "@/components/billing/ProfileSidebarButton.tsx";
import { SidebarButton } from "@/components/partials/sidebar/SidebarButton.tsx";

// This is sample data.
const data = {
  user: {
    name: "shadcn",
    email: "m@example.com",
    avatar: "/avatars/shadcn.jpg",
  },
  teams: [
    {
      name: "Acme Inc",
      logo: GalleryVerticalEnd,
      // plan: "Enterprise",
    },
    {
      name: "Acme Corp.",
      logo: AudioWaveform,
      // plan: "Startup",
    },
    {
      name: "Evil Corp.",
      logo: Command,
      // plan: "Free",
    },
  ],
  navMain: [
    {
      title: "Playground",
      url: "#",
      icon: SquareTerminal,
      isActive: true,
      items: [
        {
          title: "History",
          url: "#",
        },
        {
          title: "Starred",
          url: "#",
        },
        {
          title: "Settings",
          url: "#",
        },
      ],
    },
    {
      title: "Models",
      url: "#",
      icon: Bot,
      items: [
        {
          title: "Genesis",
          url: "#",
        },
        {
          title: "Explorer",
          url: "#",
        },
        {
          title: "Quantum",
          url: "#",
        },
      ],
    },
    {
      title: "Documentation",
      url: "#",
      icon: BookOpen,
      items: [
        {
          title: "Introduction",
          url: "#",
        },
        {
          title: "Get Started",
          url: "#",
        },
        {
          title: "Tutorials",
          url: "#",
        },
        {
          title: "Changelog",
          url: "#",
        },
      ],
    },
    {
      title: "Settings",
      url: "#",
      icon: Settings2,
      items: [
        {
          title: "General",
          url: "#",
        },
        {
          title: "Team",
          url: "#",
        },
        {
          title: "Billing",
          url: "#",
        },
        {
          title: "Limits",
          url: "#",
        },
      ],
    },
  ],
  projects: [
    {
      name: "Design Engineering",
      url: "#",
      icon: Frame,
    },
    {
      name: "Sales & Marketing",
      url: "#",
      icon: PieChart,
    },
    {
      name: "Travel",
      url: "#",
      icon: Map,
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { t } = useTranslation();
  const { userSettings } = useContext(UserContext);
  const sidebarCtx = useSidebar();
  const $crisp = (window as any).$crisp;
  const [supportBtnVisible, setSupportBtnVisible] = useState(
    Branding().supportEnabled,
  );

  let { chatbotID } = useParams();
  const { pathname } = useLocation();

  const listQuery = chatbotListQuery();
  if (!chatbotID && listQuery.data?.length === 1) {
    chatbotID = listQuery.data[0].id;
  }

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        {/*<TeamSwitcher teams={data.teams} />*/} {/*TODO: Workspace switcher*/}
        <Logo />
        {/*<TeamSwitcher teams={data.teams} />*/}
      </SidebarHeader>
      <SidebarContent className="px-1">
        {/*<NavMain items={data.navMain} />*/}
        {/*<NavProjects projects={data.projects} />*/}
        <Navmenu
          menus={menuItems({
            chatbotID: chatbotID ? chatbotID : null,
            userID: userSettings.userID,
          })}
        />

        {(!pathname.startsWith("/chatbot/")) && (
          <SideBar
            className=""
            isSidebarCollapsed={false}
            toggleSidebarCollapse={() => {}}
          />
        )}
      </SidebarContent>
      <SidebarFooter>
        <ProfileSidebarButton />

        {sidebarCtx.open && !userSettings.userID && (
          <Link to="/login">
            <div className="flex items-center p-2 btn btn-primary">
              <Icon
                icon="codicon:sign-in"
                height={32}
                width={32}
                className="w-8 inline-block mr-1"
              />
              <span>{t("login_page.sign_in")}</span>
            </div>
          </Link>
        )}

        {supportBtnVisible && (
          <div
            onClick={() => {
              $crisp.push(["do", "chat:show"]);
              $crisp.push(["do", "chat:open"]);
              setSupportBtnVisible(false);
            }}
          >
            <SidebarButton icon="mdi:support">
              <div className="ml-2 text-center">{t("feedback_support")}</div>
            </SidebarButton>
          </div>
        )}
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
